import { API_URLS } from "../../config/apiUrls";
import axiosInstance from "../../config/axios";

export const getRatingReviewFn = (reqBody) => {
    try {
        const response = axiosInstance.get(API_URLS.rating_review, {
            params: reqBody,
        });
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};



export const deleteRatingReviewFn = (reqBody) => {
    try {
        const response = axiosInstance.delete(API_URLS.rating_review, {
            data: reqBody,
        });
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};

export const patchRatingReviewFn = (reqBody, url) => {
    try {
        const response = axiosInstance.patch(API_URLS.rating_review, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};
